import { render, staticRenderFns } from "./DoRight.vue?vue&type=template&id=40cf1ec8&scoped=true&"
import script from "./DoRight.vue?vue&type=script&lang=js&"
export * from "./DoRight.vue?vue&type=script&lang=js&"
import style0 from "./DoRight.vue?vue&type=style&index=0&id=40cf1ec8&lang=scss&scoped=true&"
import style1 from "./DoRight.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40cf1ec8",
  null
  
)

export default component.exports